import React from "react"
import {TextFieldSeeker} from "@ui-seeker/core"

import {useUserSettingsTier, useUserSettingsTierValidator} from "../../@hooks"
import {userSettingsTierFormData} from "../../@signals"


export default function UserSettingTierDrawerName() {
	const {handleChangeTierFormData} = useUserSettingsTier()
	const {nameError} = useUserSettingsTierValidator()

    return <TextFieldSeeker
		error={nameError}
		value={userSettingsTierFormData.value?.name || []}
		onChange={e => handleChangeTierFormData(e.target.value, 'name')}
	/>
}